import React from 'react';
import { motion } from 'framer-motion';

interface SlideContainerProps {
  children: React.ReactNode;
  className?: string;
  backgroundGradient?: boolean;
}

export const SlideContainer: React.FC<SlideContainerProps> = ({
  children,
  className = '',
  backgroundGradient = false
}) => {
  return (
    <div className={`slide-container ${backgroundGradient ? 'bg-gradient-to-br from-off-white to-gray-50' : ''} ${className}`}>
      <motion.div
        className="slide-content"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        {children}
      </motion.div>
    </div>
  );
};

export const SlideTitle: React.FC<{
  children: React.ReactNode;
  className?: string;
  animated?: boolean;
}> = ({ children, className = '', animated = true }) => {
  if (animated) {
    return (
      <motion.h1
        className={`slide-title ${className}`}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        {children}
      </motion.h1>
    );
  }
  
  return <h1 className={`slide-title ${className}`}>{children}</h1>;
};

export const SlideSubtitle: React.FC<{
  children: React.ReactNode;
  className?: string;
  animated?: boolean;
}> = ({ children, className = '', animated = true }) => {
  if (animated) {
    return (
      <motion.p
        className={`slide-subtitle ${className}`}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      >
        {children}
      </motion.p>
    );
  }
  
  return <p className={`slide-subtitle ${className}`}>{children}</p>;
};

export const SectionDivider: React.FC<{ className?: string }> = ({ className = '' }) => {
  return (
    <motion.div
      className={`section-divider ${className}`}
      initial={{ scaleX: 0 }}
      animate={{ scaleX: 1 }}
      transition={{ duration: 1, delay: 0.6 }}
    />
  );
};